import React from "react";

import { Button } from "app/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "app/components/ui/dialog";

interface Props {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
  onConfirm: (hasPhysicalSim: boolean) => void;
}

export const VLEMobileSimDialog = ({
  showDialog,
  setShowDialog,
  onConfirm,
}: Props) => {
  return (
    <Dialog open={showDialog} onOpenChange={setShowDialog}>
      <DialogContent className="gap-5 sm:gap-6 lg:gap-[1.94rem] bg-white w-[95%] sm:max-w-[33.5rem] p-4 sm:p-5 lg:p-6">
        <DialogHeader className="p-0 bg-transparent">
          <DialogTitle className="text-xl font-bold leading-6 text-black md:leading-7 lg:text-2xl font-mobile">
            Do you have a VLE mobile SIM with you?
          </DialogTitle>
          <DialogDescription className="text-[0.825rem] sm:text-sm font-medium leading-4 sm:leading-5 text-[#3C3C3C]">
            If you have a VLE Mobile SIM, you can activate it now with a new
            number or transfer your existing one.
          </DialogDescription>
        </DialogHeader>
        <div className="grid items-center grid-cols-2 gap-2 sm:gap-3">
          <Button
            type="button"
            variant="outline"
            className="h-[2.5rem] sm:h-[3rem] md:h-[3.25rem] lg:h-[3.375rem]"
            onClick={() => {
              setShowDialog(false);
              onConfirm(false);
            }}
          >
            No
          </Button>
          <Button
            type="button"
            variant="primary"
            className="h-[2.5rem] sm:h-[3rem] md:h-[3.25rem] lg:h-[3.375rem]"
            onClick={() => {
              setShowDialog(false);
              onConfirm(true);
            }}
          >
            Yes
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
